import React from 'react'

import { Color, Heading3, Standfirst1 } from '@gousto-internal/citrus-react'
import Markdown from 'react-markdown'

type RecipeGroupingTitleProps = {
  color?: Color
  description?: string
  title: string
}

export const RecipeGroupingTitle = ({ color, description, title }: RecipeGroupingTitleProps) => (
  <>
    <Heading3 color={color}>{title}</Heading3>
    {description && (
      <Markdown
        source={description}
        renderers={{
          paragraph: ({ children }) => (
            <Standfirst1 data-testid="recipe-grouping-description" color={color}>
              {children}
            </Standfirst1>
          ),
        }}
      />
    )}
  </>
)
